import hanldeCart from "./hanldeCart";
import { combineReducers } from "redux";

const rootReducers = combineReducers({
    hanldeCart,
})

export default rootReducers;